/**
 * Public /news pages, nav links, and sitemap entries.
 * To restore: set true, move `src/app/(pages)/news/_restore` pages back, and
 * delete `src/app/(pages)/news/[[...slug]]/route.ts`.
 */

export const NEWS_ENABLED = false;

function pathnameOf(href: string): string {
  const trimmed = href.trim();
  if (!trimmed) return "";
  try {
    if (/^https?:\/\//i.test(trimmed)) {
      return new URL(trimmed).pathname;
    }
  } catch {
    return "";
  }
  const withSlash = trimmed.startsWith("/") ? trimmed : `/${trimmed}`;
  return withSlash.split("?")[0].split("#")[0];
}

/** True for `/news` and any nested path; not `/newsletter` or `/api/news`. */
export function isNewsPath(pathname: string): boolean {
  const path = pathname.split("?")[0].split("#")[0];
  const normalized = path.length > 1 && path.endsWith("/") ? path.slice(0, -1) : path;
  return normalized === "/news" || normalized.startsWith("/news/");
}

export function isNewsHref(href: string): boolean {
  return isNewsPath(pathnameOf(href));
}

export function withoutNewsHrefs<T extends { url?: string; href?: string }>(items: T[]): T[] {
  if (NEWS_ENABLED) return items;
  return items.filter((item) => !isNewsHref(item.url ?? item.href ?? ""));
}
